import type { SnackbarQueueMessage } from 'vuetify';

type SnackbarLocation = 'bottom center' | 'top center' | 'top start' | 'top end';

interface AppSnackbarMessage extends Exclude<SnackbarQueueMessage, string> {
    location: SnackbarLocation;
    text: string;
    timeout: number;
    color: string;
    prependIcon?: string;
}

export const snackbarMessages = ref<AppSnackbarMessage[]>([]);

export function showMessage(
    message: string,
    _showCloseButton: boolean = false,
    color: string = 'toastLightGreen',
    duration: number = 3000,
    top: boolean = false,
    left: boolean = false,
    right: boolean = false,
    icon: string | null = null
) {
    let location: SnackbarLocation = 'bottom center';
    if (top && right) {
        location = 'top end';
    } else if (top && left) {
        location = 'top start';
    } else if (top) {
        location = 'top center';
    }

    setTimeout(() => {
        snackbarMessages.value.push({
            text: message,
            color,
            timeout: duration,
            location,
            ...(icon ? { prependIcon: icon } : {}),
        });
    }, 100);
}

export function failMessage(message: string) {
    showMessage(message, false, 'toastLightRed', 3000, false, false, false, mdiAlertCircleOutline);
}
export function successMessage(message: string) {
    showMessage(message, false, 'toastLightGreen', 3000, false, false, false, mdiCheckboxMarkedCircle);
}
